import React from "react";
import { Card, Badge, ProgressBar } from "react-bootstrap";
import { Clock, Repeat } from "react-feather";

const RetentionOpportunityCard = ({
  data,
  selected,
  onSelect,
  disabled = false,
}) => {
  const {
    customer_name,
    message_type,
    suggested_message,
    expected_value,
    probability,
    segment,
    days_to_reorder,
    avg_interval,
    last_order_days,
    status,
  } = data;

  const getBadgeMeta = () => {
    switch (message_type) {
      case "refill":
        return {
          label: "• Ready to reorder",
          cls: "bg-success-subtle text-success",
        };

      case "reorder":
        return {
          label: "• Upcoming",
          cls: "bg-warning-subtle text-warning0",
        };

      case "reward":
        return {
          label: "• At Risk",
          cls: "bg-danger-subtle text-danger",
        };

      default:
        return {
          label: "Customer",
          cls: "bg-light text-dark",
        };
    }
  };

  const badge = getBadgeMeta();

  const reorderDays =
    days_to_reorder ??
    Math.round((1 - (probability || 0)) * 10);

  const isOverdue = reorderDays < 0;

  const progress = Math.min(
    Math.max(100 - Math.abs(reorderDays * 10), 5),
    100
  );
  const smsSent = status === "sent";
  return (
    <div className="col-12 col-lg-4">
      <Card className="shadow-sm border-0 rounded-4 p-3 h-100">

        {/* TOP */}
        <div className="text-end mb-2">
          <Badge className={`px-2 py-1 border-0 font8-bdg ${badge.cls}`}>
            {badge.label}
          </Badge>
        </div>

        {/* CUSTOMER */}
        <div className="fw-semibold mb-2">
          <div
            className="rounded-3 d-flex align-items-center justify-content-center me-2 mt-1"
            style={{
              width: "40px",
              height: "40px",
              background: "rgb(0, 48, 110)",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "bold",
              float: "left",
            }}
          >
            {customer_name?.charAt(0)?.toUpperCase() || "C"}
          </div>

          <p className="mb-0">{customer_name}</p>

          <div className="text-muted font8 mb-2 d-flex align-items-center flex-wrap gap-2">
            <span className="d-flex align-items-center gap-1">
              <Clock size={14} />
              <span>{last_order_days || 0}d ago</span>
            </span>

            <span>•</span>

            <span className="d-flex align-items-center gap-1">
              <Repeat size={14} />
              <span>{avg_interval || 0}d cycle</span>
            </span>
          </div>
        </div>

        {/* TIMING */}
        <div className="d-flex justify-content-between align-items-center mb-1">
          <small className="fw-medium font8">
            Reorder timing
          </small>

          <small className="text-muted font8">
            {isOverdue
              ? `${Math.abs(Math.round(reorderDays))}d overdue`
              : `${Math.round(reorderDays)}d`}
          </small>
        </div>

        <ProgressBar
          now={progress}
          className={`mb-3 ${
            isOverdue ? "bg-danger" : "bg-warning"
          }`}
          style={{
            height: "6px",
            borderRadius: "6px",
          }}
        />

        {/* MESSAGE */}
        <div className="mb-0">
          <div className="text-muted font7 mb-1 d-flex align-items-center gap-1">
            <span>✨</span>
            Suggested Message
          </div>

          <div
            className="p-2 rounded-3 border font8"
            style={{
              background: "#f8f9fb",
              lineHeight: "1.4",
              color: "#333",
            }}
          >
            {suggested_message}
          </div>
        </div>

        {/* FOOTER */}
        <div className="d-flex justify-content-between align-items-center mt-auto pt-2 border-top">
          <div className="text-muted font8-bdg">
            <span className="fw-semibold">
              KES {Number(expected_value || 0).toLocaleString()}
            </span>
            <span className="ms-1">potential</span>
          </div>

          <div
            className={`d-flex align-items-center gap-2 px-2 py-1 ${
              selected ? "bg-primary br-10 text-white" : ""
            }`}
            style={{
              cursor: disabled ? "not-allowed" : "pointer",
              opacity: disabled ? 0.65 : 1,
            }}
            onClick={() => {
              if (!disabled) onSelect();
            }}
          >
            <input
              type="checkbox"
              className="form-check-input m-0 custom-checkbox-nm"
              checked={selected || false}
              disabled={disabled}
              onChange={onSelect}
              onClick={(e) => e.stopPropagation()}
            />

            <span
              className={`small ${
                selected
                  ? "fw-semibold font8-bdg"
                  : "text-muted"
              }`}
            >
              {disabled
                ? smsSent
                  ? "SMS Sent"
                  : "Campaign Closed"
                : selected
                ? "Selected"
                : "Send Message"}
            </span>
          </div>

        </div>
      </Card>
    </div>
  );
};

export default RetentionOpportunityCard;